import TagManager from 'react-gtm-module';

import { once } from './clickTracking';

export interface TrackPlpHeroCatNavClickProps {
  data: {
    /** Path of the PLP the nav was clicked from, without its query string. */
    interactionLocation: string;
    linkUrl: string;
    linkText: string;
    coOpBrand: string | null;
    /** 0-based position of the tile within the carousel. */
    index: number;
  };
  /**
   * Invoked once the GTM event has been dispatched (or after `eventTimeout`
   * ms as a fallback). Use this to defer navigation so the analytics hit is
   * not lost when the page unloads.
   */
  eventCallback?: () => void;
  /** Max time (ms) to wait for the event before running `eventCallback`. */
  eventTimeout?: number;
}

export const trackPlpHeroCatNavClick = ({
  data,
  eventCallback,
  eventTimeout = 500,
}: TrackPlpHeroCatNavClickProps) => {
  const { interactionLocation, linkUrl, linkText, coOpBrand, index } = data;
  const onSent = eventCallback ? once(eventCallback) : undefined;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_plp_hero_cat_nav',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        coop_brand: coOpBrand,
        index,
      },
      // GTM invokes `eventCallback` once all tags for this event have fired,
      // or after `eventTimeout`, letting the caller defer navigation.
      ...(onSent && { eventCallback: onSent, eventTimeout }),
    },
  });

  // Fallback: if GTM is blocked or never loaded it will not invoke the
  // callback, so guarantee navigation still happens.
  if (onSent) {
    setTimeout(onSent, eventTimeout + 250);
  }
};
